<!-- START : Page  -->

<div class="page__card position-relative error-page">
  <div>
      <div>
          <div class="page-not-found-modal no-access">
              <!-- <h1 style="text-align: center;">
                  404
              </h1> -->
              <!-- <div style="text-align: center; padding: 0px 0px 16px">
                  <img class="ih" src="assets/images/404.png">
              </div> -->
              <h3 style="text-align: center;min-height: 330px;padding-top: 150px; ">
                  {{pageTitle}} comes here...
              </h3>
          </div>
      </div>
  </div>
</div>

<!-- END : Page  -->

